// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yk6tMGeCI4ucxz {
  position: relative;
  width: 90dvw;
  height: 90dvh;
  margin: 0 auto;
  text-align: center;
}
.sOTB8D1F_ds392 > div {
  margin: 0;
}
.sOTB8D1F_ds392 {
  scrollbar-gutter: initial;
}
.ktse_rRahJHRCx {
  display: flex;
  justify-content: center;
  height: 100%;
  border-radius: 24px;
  background-color: #1868db;
  color: #ffffff;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `yk6tMGeCI4ucxz`,
	"overlayOverrides": `sOTB8D1F_ds392`,
	"screenWrapper": `ktse_rRahJHRCx`
};
export default ___CSS_LOADER_EXPORT___;
